module.exports = __webpack_public_path__ + "img/newEn.8eb7aaca.png";